import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-miterlimit": "133.3",
      d: "M2.032 10c-.466-.614-.698-1.008-.698-2s.284-1.46.85-2.198C3.316 4.332 5.212 2.666 8 2.666c1.311 0 1.786.19 2.53.5M13.816 5.802c.566.736.85 1.104.85 2.198 0 1.094-.284 1.46-.85 2.198-1.132 1.47-3.028 3.136-5.816 3.136-1.665 0-2.33-.338-3.236-.844M6.01 7.796A2 2 0 0 1 8 6c1.036 0 .164.006.244.014"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-miterlimit": "133.3",
      d: "M9.99 8.196A1.999 1.999 0 0 1 8 10c-1.038 0-.37-.026-.544-.074"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      d: "M1.334 12.978 14.666 2.666"
    }, null, -1)
  ]))]))
}
export default { render: render }